import React from 'react';
import { H2, P, OL, LI, FeatureLink } from './_shared';

export default {
  slug: 'creating-deals',
  title: 'Creating a deal',
  category: 'leads-deals',
  summary: 'How deals relate to clients and folders, and what to fill in when you create one.',
  searchTerms: ['deal', 'new deal', 'transaction', 'property'],
  related: ['adding-clients', 'folders-intro', 'managing-pipeline'],
  Body: () => (
    <>
      <P>
        A <strong>deal</strong> is one specific transaction. Every deal
        belongs to a client and most deals automatically spawn a{' '}
        <FeatureLink to="/help/folders-intro">folder</FeatureLink> to hold the
        paperwork.
      </P>

      <H2>Creating a deal</H2>
      <OL>
        <LI>Open <FeatureLink to="/deals">Deals → New Deal</FeatureLink>.</LI>
        <LI>Pick the client (or create a new one on the fly).</LI>
        <LI>Type (purchase, listing, rental), property address, budget, target close date.</LI>
        <LI>Save. A folder is created in <em>draft</em> status with a Purchase Agreement waiting to be filled in.</LI>
      </OL>

      <H2>Fields that earn their keep</H2>
      <P>
        Three fields are worth filling in even when they feel optional —
        they're what the AI uses to decide what to suggest:
      </P>
      <ul style={{ margin: '0 0 14px', paddingLeft: 22 }}>
        <li><strong>Budget</strong> — drives the "is this client priced for this property" check.</li>
        <li><strong>Close date</strong> — drives the timeline-risk flag.</li>
        <li><strong>MLS number</strong> — auto-fills property details and pulls comps for the proposal.</li>
      </ul>

      <H2>Editing & deleting</H2>
      <P>
        Open the deal card and click "Edit." Deletes are soft — the deal
        moves to "Closed Lost" with a deletion reason and stays searchable
        for compliance for 7 years.
      </P>
    </>
  ),
};
